import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.reply)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _cache[3] || (_cache[3] = _createTextVNode(" [ ")),
          (_ctx.isOwner)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[0] || (_cache[0] = [
                _createTextVNode(" Sent by "),
                _createElementVNode("strong", null, "You", -1)
              ])))
            : (_ctx.item.SentByCreator)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Sent by ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.item.UserFullName), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Sent by ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.item.CreatorUserFullName), 1)
                ])),
          _createTextVNode(" on " + _toDisplayString(_ctx.getTimeAgo(_ctx.item.CreationDate)) + "]", 1)
        ]))
      : (_ctx.item)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _cache[6] || (_cache[6] = _createTextVNode(" [ ")),
            (_ctx.isOwner && _ctx.item.UserFullName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createTextVNode(" Sent to ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.item.UserFullName), 1)
                ]))
              : (_ctx.item.CreatorUserFullName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Sent by ")),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.item.CreatorUserFullName), 1)
                  ]))
                : _createCommentVNode("", true),
            _createTextVNode(" on " + _toDisplayString(_ctx.getTimeAgo(_ctx.item.CreationDate)) + "]", 1)
          ]))
        : _createCommentVNode("", true)
  ]))
}